module.exports = __webpack_public_path__ + "img/ScaledAccess-AccessFeatures-Icon-EventStream.svg";